import gsap, { Power1, Power2 } from 'gsap';
import { SplitText } from 'gsap/SplitText';

gsap.registerPlugin(SplitText);

import { GetBy } from '../_app/cuchillo/core/Element';
import { Scroll } from '../_app/cuchillo/scroll/Scroll';
import { Maths } from '../_app/cuchillo/utils/Maths';
import BGImage from '../layout/BGImage';
import ScrollItem__BlockDefault from './ScrollItem__BlockDefault';
import ProductScene from '../3D/ProductScene';

const IMG_RANDOM = {
  speed: [0.05, 0.15],     // magnitud del parallax
  rotStart: [5, 15],       // magnitud de la rotació base (deg)
  rotDelta: [30, 55],       // magnitud del delta de rotació (deg, × --progress de la línia)
};

class ScrollItem__BillboardProject extends ScrollItem__BlockDefault {
  //==================================================================================================================
  //          CONSTRUCTOR
  //==================================================================================================================
  constructor(__link, __index, __scroller) {
    super(__link, __index, __scroller);

    const bgEl = GetBy.class('__bg', this.container)[0];
    const bgUrl = bgEl.dataset.src;
    BGImage.set(bgUrl, bgEl.dataset.video);

    this._randomizeImages();

    const imagesEl = GetBy.class('images', this.container)[0];
    if (imagesEl) {
      [...imagesEl.children].forEach(child => {
        if (!child.classList.contains('__obj')) gsap.set(child, { opacity: 0 });
      });
    }

    this.onHide = () => {
      BGImage.hide();
    };

    this.onMove = () => {
      this.loop();
    };
  }

  _randomizeImages() {
    const listEl = GetBy.class('text-list', this.container)[0];
    if (!listEl) return;

    const items = [...GetBy.selector('.img, .obj', listEl)];
    // Magnitud aleatòria dins [min,max] amb signe aleatori → |valor| ≥ min (mai a prop de 0).
    const rndSigned = (min, max) => (min + Math.random() * (max - min)) * (Math.random() < 0.5 ? 1 : -1);

    items.forEach((item, i) => {
      // Posició: alternem esquerra/dreta.
      item.classList.remove('--left', '--right', '--center');
      item.classList.add(i % 2 === 0 ? '--left' : '--right');

      // Parallax random (signe aleatori).
      item.style.setProperty('--speed', rndSigned(IMG_RANDOM.speed[0], IMG_RANDOM.speed[1]).toFixed(2));

      // Rotació: start amb signe aleatori i delta AMB EL MATEIX SIGNE que start → la
      // rotació (start + delta·progress) mai creua 0: sempre es veu inclinada.
      const rotStart = rndSigned(IMG_RANDOM.rotStart[0], IMG_RANDOM.rotStart[1]);
      const sign = rotStart < 0 ? -1 : 1;
      const rotDelta = sign * (IMG_RANDOM.rotDelta[0] + Math.random() * (IMG_RANDOM.rotDelta[1] - IMG_RANDOM.rotDelta[0]));
      item.style.setProperty('--rotate-start', `${rotStart.toFixed(1)}deg`);
      item.style.setProperty('--rotate-delta', `${rotDelta.toFixed(1)}deg`);
    });

    // smile-of-chaos: l'última imatge ha d'estar centrada.
    if (listEl.dataset.slug === 'smile-of-chaos') {
      const imgs = items.filter(it => it.classList.contains('img'));
      const last = imgs[imgs.length - 1];
      if (last) {
        last.classList.remove('--left', '--right');
        last.classList.add('--center');
      }
    }
  }

  //==================================================================================================================
  //          PUBLIC
  //==================================================================================================================
  loop() {
    BGImage.progress = this.progress;
  }

  showCb() {
    this.loop();

    super.showCb();
    BGImage.show();

    const imagesEl = GetBy.class('images', this.container)[0];
    if (!imagesEl) return;

    // L'__obj 3D sempre està a opacity 1 (no s'anima); aquí només fem aparèixer les imatges 2D.
    [...imagesEl.children].forEach((child, i) => {
      if (child.classList.contains('__obj')) return;
      gsap.to(child, { opacity: 1, duration: 1, delay: i * 0.3 });
    });
  }
}

Scroll._registerClass('billboard-project', ScrollItem__BillboardProject);
